import React from "react";
import { Link } from "react-router-dom";
import { SITE_CONFIG } from "../config/siteConfig";
import "../css/policy.scss";

function PolicyLayout({ title, intro, children }) {
  const headingId = `policy-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

  return (
    <main className="policy-page" tabIndex={-1} aria-labelledby={headingId}>
      <article className="policy-page__article">
        <header className="policy-page__header">
          <p className="policy-page__eyebrow">{SITE_CONFIG.brand} · {SITE_CONFIG.operatingRegion}</p>
          <h1 id={headingId}>{title}</h1>
          {intro && <p className="policy-page__intro">{intro}</p>}
          <p className="policy-page__updated">Last updated: {SITE_CONFIG.policyUpdated}</p>
        </header>
        <div className="policy-page__body">{children}</div>
        <footer className="policy-page__contact">
          <h2>Contact for this policy</h2>
          <p>
            Email <a href={`mailto:${SITE_CONFIG.supportEmail}`}>{SITE_CONFIG.supportEmail}</a> with the relevant order number and enough detail for us to locate the issue.
          </p>
          <p><Link to="/policies">View the complete policy guide</Link></p>
        </footer>
      </article>
    </main>
  );
}

export default PolicyLayout;
